module.exports = __webpack_public_path__ + "static/media/FreightImg.b07310cc.png";